export { DMS_MODULE } from '../constants';
export const CRUMB_LABEL_KEY = 'fltgrdUserDefColumns';
export const NAME = 'UserDefColumns';
